import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getServices = () => api.get("/services").then((r) => r.data);
export const getPortfolio = () => api.get("/portfolio").then((r) => r.data);
export const getTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const getPricing = () => api.get("/pricing").then((r) => r.data);
export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
